import { render, staticRenderFns } from "./ExampleItineraryCard.vue?vue&type=template&id=2e2ea2df&scoped=true&"
import script from "./ExampleItineraryCard.vue?vue&type=script&lang=js&"
export * from "./ExampleItineraryCard.vue?vue&type=script&lang=js&"
import style0 from "./ExampleItineraryCard.vue?vue&type=style&index=0&id=2e2ea2df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2ea2df",
  null
  
)

export default component.exports